import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { styled } from 'styled-components';

import { getOrderStatusConfig } from '../../constants/orderStatus';

const ChangeStatusConfirmationModal = ({ actionHandler, closeHandler, data, show, isSubmitting }) => {
    // Extraer los datos del objeto
    const { orderNumber, vehiclePlate, currentStatus, newStatus } = data;

    // Obtener configuración de estados
    const currentStatusConfig = getOrderStatusConfig(currentStatus);
    const newStatusConfig = getOrderStatusConfig(newStatus);

    // ----- Actions
    const handleClose = () => {
        closeHandler();
    };

    const handleAction = () => {
        actionHandler();
    };

    // ----- Render
    return (
        <Modal show={show} size='lg' backdrop='static' centered onHide={handleClose}>
            <Modal.Header className='fw-bold' closeButton>
                Confirmación de Cambio de Estado
            </Modal.Header>
            <Modal.Body>
                <FieldRow>
                    <label className='fw-bold me-3'>N° Orden:</label>
                    <p>{orderNumber}</p>
                </FieldRow>
                <FieldRow>
                    <label className='fw-bold me-3'>Placa:</label>
                    <p>{vehiclePlate}</p>
                </FieldRow>
                <FieldRow>
                    <label className='fw-bold me-3'>Estado actual:</label>
                    <StatusBadge color={currentStatusConfig.color}>{currentStatusConfig.label}</StatusBadge>
                </FieldRow>
                <FieldRow>
                    <label className='fw-bold me-3'>Estado nuevo:</label>
                    <StatusBadge color={newStatusConfig.color}>{newStatusConfig.label}</StatusBadge>
                </FieldRow>

                <WarningNote>
                    <strong>Nota:</strong> Este cambio de estado no es reversible.
                </WarningNote>
            </Modal.Body>
            <Modal.Footer>
                <p className='fw-bold me-3'>¿Desea cambiar el estado de la orden?</p>
                <CancelButton onClick={handleClose} disabled={isSubmitting}>
                    Cancelar
                </CancelButton>
                <ConfirmButton onClick={handleAction} disabled={isSubmitting}>
                    {isSubmitting ? (
                        <>
                            <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                            Procesando...
                        </>
                    ) : (
                        'Confirmar'
                    )}
                </ConfirmButton>
            </Modal.Footer>
        </Modal>
    );
};

const FieldRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    label {
        margin: 0;
    }

    p {
        margin: 0;
    }
`;

const StatusBadge = styled.span`
    padding: 4px 12px;
    border-radius: 50px;
    background-color: ${(props) => props.color};
    color: #fff;
    font-weight: 500;
    font-size: 13px;
    white-space: nowrap;
`;

const WarningNote = styled.div`
    margin-top: 20px;
    padding: 12px 15px;
    background-color: #fff3cd;
    border-left: 4px solid #ffc107;
    border-radius: 4px;
    color: #856404;
    font-size: 14px;

    strong {
        color: #856404;
    }
`;

const CancelButton = styled(Button)`
    background-color: #a5a7a0;
    border-color: #a5a7a0;

    &:hover {
        background-color: #8c8e88;
        border-color: #8c8e88;
    }

    &:disabled {
        background-color: #6c757d;
        border-color: #6c757d;
    }
`;

const ConfirmButton = styled(Button)`
    background-color: #d04437;
    border-color: #d04437;

    &:hover {
        background-color: #b73d32;
        border-color: #b73d32;
    }

    &:disabled {
        background-color: #6c757d;
        border-color: #6c757d;
    }

    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
    }
`;

export default ChangeStatusConfirmationModal;
